import React from 'react';
import PropTypes from 'prop-types';

import { DeprecatedTooltip } from 'shared/components';

import theme from './AccountDetails.scss';
import { AccountDetailsTooltip, AuthorizedUserIcon } from '../';

const propTypes = {
  rtl: PropTypes.bool.isRequired,
  isTooltipShowed: PropTypes.bool.isRequired,
  handleTooltipClick: PropTypes.func.isRequired,
  handleIconClick: PropTypes.func.isRequired,
  setTooltipState: PropTypes.func.isRequired,
};

const defaultProps = {};

const AccountDetails = ({
  intl,
  rtl,
  isTooltipShowed,
  handleTooltipClick,
  handleIconClick,
  setTooltipState,
}) => (
  <DeprecatedTooltip
    rtl={ !rtl }
    message={ isTooltipShowed ? <AccountDetailsTooltip closeTooltip={ () => setTooltipState(false) } /> : null }
    messageRootClassName={ theme.tooltip }
    onClick={ handleTooltipClick }
  >
    <button
      className={ theme.root }
      onClick={ handleIconClick }
      tabIndex={ isTooltipShowed ? -1 : 0 }
      aria-label={ intl.formatMessage({ id: 'PatientPortal.Header.AccountDetailsButton.Accessibility.Title' }) }
    >
      <AuthorizedUserIcon />
    </button>
  </DeprecatedTooltip>
);

AccountDetails.propTypes = propTypes;
AccountDetails.defaultProps = defaultProps;

export default AccountDetails;
